import * as React from 'react';
import * as styles from './Carousel.css';
import { CarouselContentElement } from './carouselContentElement/CarouselContentElement';
import { IUser } from '../../interfaces/IUser';
import { ILike } from '../../interfaces/ILike';
import { IMessage } from '../../interfaces/IMessage';
import { ICarouselContentElement } from '../../interfaces/ICarouselContentElement';
import { Environment } from '../../services/Environment';
import { Helper } from '../../Helper';
import { IAMessageVideo } from '../messages/video/MessageVideo';
import DateTimeService from '../../services/DateTimeService';
import { IFontSlots } from '../../interfaces/IFontSlots';

export interface IProps {
  id?: string;
  elements: ICarouselContentElement[];
  user?: IUser;
  tenant?: string;
  component?: string;
  instance?: string;
  token?: string;
  source?: string;
  environment?: "Development" | "Test" | "Production";
  width?: number;
  resultSourceId?: string;
  siteCollection?: string;
  listName?: string;
  showSkeleton?: boolean;
  likesEnabled?: boolean;
  commentsEnabled?: boolean;
  backgroundColor?: string;
  borderColor?: string;
  borderRadius?: number;
  highlightColor?: string;
  itemTitleColor?: string;
  itemTextColor?: string;
  carouselInterval?: number;
  itemTitleStyle?: string;
  itemTitleSize?: number;
  itemTitleAlign?: string;
  itemTitleWeight?: string;
  numberOfElements?: number;
  isMobile?: boolean;
  reactionOptions: string[];
  showEmojiPickerExpandButton: boolean;
  onClickEdit?: (content: any) => void;
  onClickOpen?: (content: any) => void;
  onClickPreview?: (content: any) => void;
  onClickCopy?: (content: any) => void;
  onClickDelete?: (content: any) => void;
  likesUpdated?: (likes: ILike[], itemIndex: number) => void;
  commentsUpdated?: (comments: number, itemIndex: number) => void;
  commentsClick?: (message: IMessage) => void;
  showTitle?: boolean;
  showCategories?: boolean;
  showTeaser?: boolean;
  showAuthor?: boolean;
  showStartDate?: boolean;
  showLikes?: boolean;
  showComments?: boolean;
  showDropShadow?: boolean;
  messageIsOpen?: boolean;
  showUniqueViews?: boolean;
  isMessageUnread?: boolean;
  unReadMessageHighlight?: string;
  hasDarkBackground?: boolean;
  showLikesDimmed?: boolean;
  showCommentsDimmed?: boolean;
  showUniqueViewsDimmed?: boolean;
  fontSlots?: IFontSlots;
  userLocation?: string;
}

export interface IState {
  selectedIndex: number;
  messageIsOpen: boolean;
  videoPlayingID: string;
}

export class IACarousel extends React.Component<IProps, IState> {
  private dateTimeService = new DateTimeService();

  private timer: any;

  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedIndex: 0,
      messageIsOpen: false,
      videoPlayingID: undefined
    };
  }
  
  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps.carouselInterval !== this.props.carouselInterval) {
      this.stopTimer();
      this.startTimer();
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    this.setState({ messageIsOpen: props.messageIsOpen });
    if (!props.messageIsOpen && !props.showSkeleton) {
      setTimeout(() => {
        this.startTimer();
      }, 1000);
    }
    if (props.showSkeleton != this.props.showSkeleton) {
      if (props.showSkeleton) {
        this.stopTimer();
        this.setState({ selectedIndex: 0 })
      } else {
        ;
        this.startTimer();
      }
    }
  }

  public componentDidMount(): void {
    this.startTimer();
  }

  private startTimer(): void {
    if (!this.state.messageIsOpen && this.timer == undefined && this.props.elements != undefined && this.props.elements.length > 1 && !this.state.videoPlayingID) {
      const numberOfElements = this.props.numberOfElements >= 3 ? 3 : this.props.numberOfElements;
      this.timer = setInterval(() => {
        let selectedIndex = this.state.selectedIndex + 1;
        if (selectedIndex === numberOfElements) {
          selectedIndex = 0;
        }
        this.setState({ selectedIndex });
      }, this.props.carouselInterval || 5000);
    }
  }

  private stopTimer(): void {
    clearInterval(this.timer);
    this.timer = undefined;
  }

  public render(): JSX.Element {
    let minHeight = 0;
    const likesShouldBeShown = this.props.likesEnabled && this.props.showLikes;
    const commentsShouldBeShown = this.props.commentsEnabled && this.props.showComments;
    const numberOfElements = this.props.numberOfElements >= 3 ? 3 : this.props.numberOfElements;

    let iconsAmount = 0;
    if (likesShouldBeShown) {
      iconsAmount++;
    }
    if (commentsShouldBeShown) {
      iconsAmount++;
    }
    if (this.props.showUniqueViews) {
      iconsAmount++;
    }

    if (iconsAmount === 3) {
      minHeight = minHeight < 130 ? 130 : minHeight;
    }
    if (iconsAmount >= 2) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }

    let carrouselContentElementHeight = 10;
    if (this.props.showTitle) {
      carrouselContentElementHeight += 35;
    }
    if (this.props.showTeaser) {
      carrouselContentElementHeight += 45;
    }
    if (this.props.showCategories) {
      carrouselContentElementHeight += 22;
    }
    if (this.props.showAuthor || this.props.showStartDate) {
      carrouselContentElementHeight += 32;
    }
    if (minHeight > carrouselContentElementHeight) {
      carrouselContentElementHeight = minHeight;
    }

    let carrouselContentElements = [];
    let carrouselMedia = [];
    if (this.props.elements != undefined && this.props.elements.length > 0) {
      this.props.elements.forEach((element: ICarouselContentElement, index) => {



        if (numberOfElements > index) {
          carrouselContentElements.push(
            <CarouselContentElement
              selected={this.state.selectedIndex === index}
              user={this.props.user}
              author={element.author}
              id={element.id}
              key={element.id}
              tenant={this.props.tenant}
              component={this.props.component}
              instance={this.props.instance}
              token={this.props.token}
              source={this.props.source}
              index={index}
              item={element.item}
              environment={this.props.environment}
              title={element.title}
              image={element.image}
              videoUrl={element.videoUrl}
              teaser={element.teaser}
              categories={element.categories}
              showSkeleton={this.props.showSkeleton}
              likesEnabled={this.props.likesEnabled}
              commentsEnabled={this.props.commentsEnabled}
              isMobile={this.props.isMobile}
              modifiedDate={element.startDate}
              backgroundColor={this.state.selectedIndex === index ? this.props.backgroundColor : "#ffffff"}
              borderColor={this.props.borderColor}
              highlightColor={this.state.selectedIndex === index ? this.props.highlightColor : (Helper.isLightColor(this.props.highlightColor) ? "#333333" : this.props.highlightColor)}
              itemTitleColor={this.state.selectedIndex === index ? this.props.itemTitleColor : "#333333"}
              itemTextColor={this.state.selectedIndex === index ? this.props.itemTextColor : "#333333"}
              itemTitleStyle={this.props.itemTitleStyle}
              itemTitleSize={this.props.itemTitleSize}
              itemTitleAlign={this.props.itemTitleAlign}
              itemTitleWeight={this.props.itemTitleWeight}
              hasDarkBackground={this.props.hasDarkBackground}
              fontSlots={this.props.fontSlots}
              userLocation={this. props.userLocation}
              likes={element.likes}
              commentCount={element.commentCount}
              showEmojiPickerExpandButton={this.props.showEmojiPickerExpandButton}
              reactionOptions={this.props.reactionOptions}
              height={carrouselContentElementHeight}
              onClickEdit={() => {
                this.props.onClickEdit(element.item);
                this.stopTimer();
                this.setState({ videoPlayingID: undefined });
              }}
              onClickOpen={() => {
                this.props.onClickOpen(element.item);
                this.stopTimer();
                this.setState({ videoPlayingID: undefined });
              }}
              onClickDelete={() => this.props.onClickDelete(element.item)}
              likesUpdated={(likes: ILike[]) => this.props.likesUpdated(likes, index)}
              commentsUpdated={(comments: number) => this.props.commentsUpdated(comments, index)}
              commentsClick={() => this.props.commentsClick(element.item)}
              onMouseOver={(selectedIndex: number) => {
                this.setState({ selectedIndex });
                this.stopTimer();
                var videoFrame = document.getElementById(`IA_Iframe_${element.id}`)
                if (document.activeElement === videoFrame && this.state.videoPlayingID !== element.videoUrl) {
                  //iframe video is playing:
                  this.setState({ videoPlayingID: element.id },
                    () => { this.stopTimer() });
                }
                if (element.id !== this.state.videoPlayingID) {
                  // Pausing the video if user hovers over a different element
                  this.setState({ videoPlayingID: undefined });
                }
                if (this.state.videoPlayingID == undefined) {
                  this.setState({ videoPlayingID: undefined },
                    () => {
                      this.startTimer();
                    })
                }
              }}
              onMouseLeave={(selectedIndex: number) => {
                this.setState({ selectedIndex });
                var videoFrame = document.getElementById(`IA_Iframe_${element.id}`)
                if (document.activeElement === videoFrame && this.state.videoPlayingID !== element.videoUrl) {
                  this.setState({ videoPlayingID: element.id },
                    () => { this.stopTimer() });
                }
                if (this.state.videoPlayingID == undefined) {
                  this.setState({ videoPlayingID: undefined },
                    () => {
                      this.startTimer();
                    })
                }
              }}
              showTitle={this.props.showTitle}
              showCategories={this.props.showCategories}
              showTeaser={this.props.showTeaser}
              showAuthor={this.props.showAuthor}
              showStartDate={this.props.showStartDate}
              showLikes={this.props.showLikes && !element.iaConfiguration?.disableLikes}
              showComments={this.props.showComments && !element.iaConfiguration?.disableComments}
              showDropShadow={this.props.showDropShadow}
              showCommandBarItems={false}
              showUniqueViews={this.props.showUniqueViews}
              uniqueViewsCount={element.uniqueViewsCount}
              isMessageUnread={element.isUnread}
              unReadHighlight={this.props.unReadMessageHighlight}
              showPinIcon={element.showPinIcon}
              showLikesDimmed={this.props.showLikesDimmed && !element.iaConfiguration?.disableLikes}
              showCommentsDimmed={this.props.showCommentsDimmed && !element.iaConfiguration?.isNewsLink && !element.iaConfiguration?.disableComments}
              showUniqueViewsDimmed={this.props.showUniqueViewsDimmed && this.dateTimeService.isOlderThanOneHour(element.startDate)}
            />
          );

          let image;
          if (element.image && element.image !== "" && !this.props.showSkeleton && element.item && element.item.modified) {
            if (element.iaMessageBgImagesFromBlob?.StandardLarge) {
              image = element.iaMessageBgImagesFromBlob.StandardLarge;
            } else {
              image = element.image.replace(/StandardLarge|StandardSmall|Square|Wide|Full|DefaultRendition/, "StandardLarge").replace("version=&", `version=${element.item.modified ? (new Date(element.item.modified)).toISOString().replace(/[^\d]/g, '') : ""}&ignoreCache=false&`);
              if (element.iaConfiguration && element.item.modified) {
                image = Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, image, element.item.modified ? (new Date(element.item.modified)).toISOString().replace(/[^\d]/g, '') : undefined, "StandardLarge", element?.iaConfiguration?.cropSettings, false);
              }
            }

          } else {
            image = "https://spoprod-a.akamaihd.net/files/sp-client-prod_2019-09-27.007/spdefaultbanner_light_a0bc58c25323ac7ccd8b6d2e15b0ee85.jpg";
          }
          carrouselMedia.push(
            <div
              key={`mediaElement_${element.id}`}
              className={element.videoUrl != undefined && element.image == undefined ? styles.IA_videoElement : styles.IA_imageElement}
              onClick={() => {
                this.props.onClickOpen(element.item);
                this.stopTimer();
              }}
              onMouseOver={() => {
                if (element.videoUrl != undefined) {
                  if (element.id !== this.state.videoPlayingID) {
                    this.setState({ videoPlayingID: undefined });
                  }
                }
              }}
              onMouseLeave={() => {
                if (element.videoUrl != undefined) {
                  var videoFrame = document.getElementById(`IA_Iframe_${element.id}`)
                  if (document.activeElement === videoFrame && this.state.videoPlayingID !== element.id) {
                    this.setState({ videoPlayingID: element.id },
                      () => { this.stopTimer() });
                  }
                }
              }}
              style={{
                backgroundImage: `url('${image}')`,
                height: numberOfElements * carrouselContentElementHeight,
                width: this.props.width / 2,
                opacity: this.state.selectedIndex === index ? 1 : 0,
                zIndex: this.state.selectedIndex === index ? 2 : 1,
              }}
            >
              {element.showPinIcon &&
                <div
                  className={styles.IA_pinCoverOverlay}
                  style={{
                    cursor: this.props.onClickOpen ? "pointer" : undefined
                  }}
                  onClick={this.props.onClickOpen ? () => this.props.onClickOpen(element) : undefined}
                >
                  <img
                    src="https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/pinned.png"
                    style={{
                      width: 22,
                      height: 22
                    }}
                  />
                </div>
              }
              {element.videoUrl != undefined && element.image == undefined &&
                <IAMessageVideo
                  id={element.id}
                  width={"100%"}
                  height={"100%"}
                  videoUrl={element.videoUrl}
                  environment={this.props.environment}
                  tenant={this.props.tenant}
                  token={this.props.token}
                  onPlayVideo={() => {
                    this.setState({ videoPlayingID: element.id });
                    this.stopTimer();
                  }}
                  onPause={() => {
                    this.setState({ videoPlayingID: undefined });
                  }}
                  isPlaying={!this.props.messageIsOpen && this.state.videoPlayingID === element.id && this.state.selectedIndex === index}
                  forceStop={this.props.messageIsOpen}
                />
              }
            </div>
          );
        }
      });
    }
    return (
      <div
        id={`IA_Carousel_${this.props.id}`}
        className={styles.IA_carrousel}
        style={{
          borderRadius: this.props.borderRadius,
          border: `1px solid ${this.props.borderColor ? this.props.borderColor : "transparent"}`
        }}
      >
        <div
          className={styles.IA_media}
          style={{
            height: numberOfElements * carrouselContentElementHeight
          }}
          onMouseOver={(() => {
            this.stopTimer();
          })}
          onMouseLeave={(() => {
            this.startTimer();
          })}
        >
          {carrouselMedia}
        </div>
        <div className={styles.IA_lists}>
          {carrouselContentElements}
        </div>
      </div>
    );
  }


}